import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'HOME', path: '/' },
    { name: 'ABOUT', path: '/about' },
    { name: 'PRODUCTS', path: '/products' },
    { name: 'SERVICES', path: '/services' },
    { name: 'GALLERY', path: '/gallery' },
    { name: 'CONTACT', path: '/contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-white/90 backdrop-blur-md'
      } border-b border-slate-200`}
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center flex-shrink-0" data-testid="logo-link">
            <div className="text-2xl font-bold text-[#1B365D] tracking-tight">
              POWER TECH <span className="text-[#F97316]">ENGINEERS</span>
            </div>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link, index) => (
              <div key={link.path} className="flex items-center">
                <Link
                  to={link.path}
                  data-testid={`nav-link-${link.name.toLowerCase()}`}
                  className={`px-4 py-2 text-sm font-semibold tracking-wider transition-all duration-200 rounded-sm relative group ${
                    location.pathname === link.path
                      ? 'text-[#F97316]'
                      : 'text-[#475569] hover:text-[#1B365D] hover:bg-slate-50'
                  }`}
                >
                  {link.name}
                  <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-[#F97316] transform transition-transform duration-200 ${
                    location.pathname === link.path ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
                  }`}></span>
                </Link>
                {index < navLinks.length - 1 && (
                  <span className="text-slate-300 mx-1">|</span>
                )}
              </div>
            ))}
          </div>

          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-[#1B365D] p-2 hover:bg-slate-100 rounded-sm transition-colors"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-white border-t border-slate-200 shadow-lg" data-testid="mobile-menu">
          <div className="px-6 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`mobile-nav-link-${link.name.toLowerCase()}`}
                onClick={() => setIsOpen(false)}
                className={`block py-3 px-4 text-base font-semibold tracking-wide transition-all duration-200 rounded-sm ${
                  location.pathname === link.path
                    ? 'text-[#F97316] bg-orange-50'
                    : 'text-[#475569] hover:bg-slate-50 hover:text-[#1B365D]'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};